import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { VerificationComponent } from './verification/verification.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { AuthorizeComponent } from './authorize/authorize.component';

import { NotFoundComponent } from './not-found/not-found.component';
import { RedirectComponent } from './redirect/redirect.component';
import { LogoutComponent } from './logout/logout.component';
import { environment } from 'src/environments/environment';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { AuthGuard } from 'src/app/_guard/auth.guard';
import { AutoLoginComponent } from './auto-login/auto-login.component';

const routes: Routes = [
  { path: '', redirectTo: '/login/' + environment.idProductoDefecto, pathMatch: 'full' },
  { path: 'login', redirectTo: '/login/' + environment.idProductoDefecto, pathMatch: 'full' },
  // { path: 'login', component: LoginComponent },
  { path: 'login/:idAplicacion', component: LoginComponent },
  { path: 'logout/:idAplicacion', component: LogoutComponent, canActivate: [AuthGuard] },
  { path: 'redirect/:idAplicacion', component: RedirectComponent, canActivate: [AuthGuard] },
  { path: 'autologin/:idAplicacion/:usuario', component: AutoLoginComponent },
  { path: 'authorize', component: AuthorizeComponent },
  { path: 'signup/:idAplicacion', component: SignUpComponent, },
  { path: 'forgotpassword', component: ForgotPasswordComponent },
  { path: 'verification/:idAplicacion/:username', component: VerificationComponent },
  { path: 'resetpassword/:idAplicacion/:usuario/:session', component: ResetPasswordComponent },
  { path: 'changepassword/:idAplicacion', component: ChangePasswordComponent, canActivate: [AuthGuard] },
  { path: 'notfound', component: NotFoundComponent },
  { path: 'error', component: NotFoundComponent },
  { path: 'errorcompatibility', component: NotFoundComponent },
  { path: '**', redirectTo: '/notfound' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
